import { withStyles } from '@material-ui/core/styles';
import { variables } from 'components/Theme';

export default withStyles((theme) => ({
  status: {
    width: 5,
    height: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    borderRadius: '4px 0 0 4px',
    background: '#ccc',
    '&.--active': {
      backgroundColor: variables.palette.secondary.main,
    },
    [theme.breakpoints.down('sm')]: {
      width: 16,
      height: 16,
      borderRadius: '100%',
      top: 'auto',
    },
  },
  //CARD IMAGE
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    minWidth: 300,
    width: '100%',
  },
  image: {
    position: 'relative',
    height: 100,
    [theme.breakpoints.down('xs')]: {
      width: '100% !important', // Overrides inline-style
      height: 100,
    },
    '&:hover, &$focusVisible': {
      zIndex: 1,
      '& $imageBackdrop': {
        opacity: 0.15,
      },
      '& $imageMarked': {
        opacity: 0,
      },
      '& $imageTitle': {
        border: '4px solid currentColor',
      },
    },
    '&:disabled': {
      filter: 'grayscale(1)',
      opacity: '.3',
    },
  },
  focusVisible: {},
  imageButton: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.common.white,
  },
  imageSrc: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundSize: '100%',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    margin: '16px',
  },
  imageBackdrop: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    '&.--active': {
      backgroundColor: theme.palette.common.black,
      opacity: 0.1,
      transition: theme.transitions.create('opacity'),
    },
  },
  imageTitle: {
    position: 'relative',
    padding: `${theme.spacing(4)}px ${theme.spacing(2) * 4}px ${theme.spacing(2) + 6}px`,
  },
  imageMarked: {
    height: 3,
    width: 18,
    backgroundColor: theme.palette.common.white,
    position: 'absolute',
    bottom: -2,
    left: 'calc(50% - 9px)',
    transition: theme.transitions.create('opacity'),
  },
  demo: {
    position: 'relative',
    height: 80,
    [theme.breakpoints.down('xs')]: {
      width: '100% !important', // Overrides inline-style
      height: 100,
    },
    '&:hover, &$focusVisible': {
      zIndex: 1,
      '& $imageBackdrop': {
        opacity: 0.15,
      },
      '& $imageMarked': {
        opacity: 0,
      },
      '& $imageTitle': {
        border: '4px solid currentColor',
      },
    },
  },
  demoImageSrc: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundSize: '60%',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    margin: '16px',
  },
  spanButton: {
    width: '33%',
  },
  alertMessage: {
    marginBottom: 24,
    boxShadow: 'none',
    display: 'flex',
    fontSize: 14,
    '& > div': {
      display: 'flex',
      flexDirection: 'column',
    },
  },
  contentModal: {
    width: '640px',
    maxWidth: '100%',
    height: 'auto',
    top: '50%',
    left: '50%',
    position: 'absolute',
    transform: 'translate(-50%,-50%)',
    padding: '1.5rem',
    maxHeight: '90vh',
    overflow: 'auto',
  },
  imageTable: {
    minWidth: '80px',
    height: '35px',
    display: 'flex',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    marginRight: '12px',
    backgroundSize: 'contain',
  },
  imageProviderTitle: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    color: '#596375',
    paddingRight: '1rem',
  },
  connectCell: {
    display: 'flex',
    justifyContent: 'left',

    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
}));
